import React from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import { translateStaticContent } from '../../../helpers/translateStaticContent';

const SectionNav = (props) => {
    return(
       <div className="container sectionNav">
           <h1>
              {translateStaticContent('mainPageHeading', 
              props.defaultStaticContentMainPage, props.activeLangStaticContentMainPage)}
           </h1>
           <p>
             {translateStaticContent('mainPageText', 
             props.defaultStaticContentMainPage, props.activeLangStaticContentMainPage)}
           </p>
           <NavLink to={{
                        pathname: '/transferState',
                        hash: '#transferState',
                        state: {
                        getTransferInfo: false }}} rel="noreferrer">
                    {translateStaticContent('transferInfo', 
                    props.defaultStaticContentNav, props.activeLangStaticContentNav)}
                    <span className='arrow'></span>
            </NavLink>  
           <div className="inner-menu">
                <NavLink to={{
                               pathname: '/calculator',
                               hash: '#howToSend',
                               state: {
                                 howToSend: true }
                               }} 
                              className="inner-link" rel="noreferrer">
                  <span className="send"></span>
                  <span className="item">
                    <span className="item-text">
                      {translateStaticContent('transferSend', 
                      props.defaultStaticContentNav, props.activeLangStaticContentNav)}
                    </span>
                    <span className="nav-arrow"></span>
                  </span>
                </NavLink>
                <NavLink to={{
                               pathname: '/transferState',
                               hash: '#getTransferInfo',
                               state: {
                                getTransferInfo: true }
                               }} 
                          className="inner-link" rel="noreferrer">
                  <span className="wallet"></span>
                  <span className="item">
                    <span className="item-text">
                      {translateStaticContent('transferState', 
                      props.defaultStaticContentNav, props.activeLangStaticContentNav)}
                    </span>
                    <span className="nav-arrow"></span>
                  </span>
                </NavLink>
                <NavLink to={{
                               pathname: '/calculator',
                               hash: '#calculate',
                               state: {
                                 howToSend: false }
                               }} 
                          className="inner-link" rel="noreferrer">
                  <span className="calculate"></span>
                  <span className="item">
                    <span className="item-text">
                      {translateStaticContent('transferCount', 
                      props.defaultStaticContentNav, props.activeLangStaticContentNav)}
                    </span>
                    <span className="nav-arrow"></span>
                  </span>
                </NavLink>
                <NavLink to='/maps' rel="noreferrer">
                  <span className="geo"></span>
                  <span className="item">
                    <span className="item-text">
                      {translateStaticContent('points', 
                      props.defaultStaticContentNav, props.activeLangStaticContentNav)}
                    </span>
                    <span className="nav-arrow"></span>
                  </span>
                </NavLink>
            </div> 
       </div>
    )
}

export default SectionNav;

SectionNav.propTypes = {
  defaultStaticContentNav: PropTypes.object,
  activeLangStaticContentNav: PropTypes.object,
  defaultStaticContentMainPage: PropTypes.object,
  activeLangStaticContentMainPage: PropTypes.object,
}